import 'slick-carousel';
import '../libs/waypoints';
import { ScrollTo } from './scroll-to';

function carouselNavInstance(navEl) {
  const $navEl = $(navEl);
  const $slider = $('[data-carousel-nav-slides]', $navEl);
  const $buttonsContainer = $('[data-carousel-nav-buttons]', $navEl);
  const totalSlides = $slider.data('slides-count');

  $slider.slick({
    infinite: false,
    autoplay: false,
    slidesToShow: 6,
    slidesToScroll: 3,
    arrows: true,
    appendArrows: $buttonsContainer,
    prevArrow:
      '<button class="slick-arrow slick-prev"><i class="c-icon" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 0.72937L11.0862 2.31562L4.80875 8.60437H18.5V10.8544H4.80875L11.0862 17.1431L9.5 18.7294L0.499998 9.72937L9.5 0.72937Z" fill="currentColor"></path></svg></i><span class="u-visuallyhidden">Previous slide</span></button>',
    nextArrow:
      '<button class="slick-arrow slick-next"><i class="c-icon" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 0.576416L7.91375 2.16267L14.1913 8.45142H0.5V10.7014H14.1913L7.91375 16.9902L9.5 18.5764L18.5 9.57642L9.5 0.576416Z" fill="currentColor"></path></svg></i><span class="u-visuallyhidden">Next slide</span></button>',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 2,
        },
      },
    ],
  });

  $slider.on('init', () => {
    $slider.find('.slick-slide').each(function (i) {
      $(this).attr('aria-label', `slide ${i + 1} of ${totalSlides}`);
      $(this).attr('aria-roledescription', 'slide');
    });
  });
}

function hideNavOnScrollDown() {
  const $mainNav = $('#header');
  const $carouselNav = $('#gdt-nav');
  const $distanceToTop =
    $carouselNav.prev().offset().top + $carouselNav.prev().height();

  let prevScroll = window.scrollY || document.documentElement.scrollTop;
  let curScroll;
  let direction = 0;
  let prevDirection = 0;

  const toggleNav = function (d, currentScroll) {
    if (d === 2 && currentScroll > $mainNav.height()) {
      $mainNav.addClass('hide');
      $carouselNav.removeClass('down');
      prevDirection = d;
    } else if (direction === 1) {
      $mainNav.removeClass('hide');

      if (currentScroll > $distanceToTop) {
        $carouselNav.addClass('down');
      }

      prevDirection = direction;
    }
  };

  const checkScroll = function () {
    /*
     ** Find the direction of scroll
     ** 0 - initial, 1 - up, 2 - down
     */
    curScroll = window.scrollY || document.documentElement.scrollTop;
    if (curScroll > prevScroll) {
      direction = 2;
    } else if (curScroll < prevScroll) {
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleNav(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  window.addEventListener('scroll', checkScroll);
}

function highlightSection() {
  const $navItems = $('.c-carousel-nav .c-carousel-nav__nav-item');
  const $carouselElement = $('[data-carousel-nav-slides]');
  let timeout;

  if (!$navItems.length) return;

  $navItems.each((i, navItem) => {
    const $navItem = $(navItem);
    const navItemHref = $('a', $navItem).attr('href');

    $navItem.on('click', () => {
      $carouselElement.slick('slickGoTo', i);
    });

    $(`${navItemHref}`).waypoint({
      handler(direction) {
        const activeSlide = direction === 'down' ? i : i - 1;
        const $activeItem = $($navItems[activeSlide]);
        const $activeItemTitle = $($activeItem).find('span').text();

        $navItems.removeClass('active');
        $activeItem.addClass('active');

        clearTimeout(timeout);

        timeout = setTimeout(() => {
          $carouselElement.slick('slickGoTo', activeSlide);
          // Tracking
          dataLayer.push({
            event: 'section_view',
            section_name: $activeItemTitle,
          });
        }, ScrollTo.ANIMATING_TIMING + 500);
      },
      offset: 120,
    });
  });
}

export function init() {
  const $carouselNavs = $('[data-carousel-nav]');

  if ($carouselNavs.length) {
    $carouselNavs.each((i, gallery) => {
      carouselNavInstance(gallery);
    });

    hideNavOnScrollDown();
    highlightSection();
  }
}
